import { validateWallDecorTemplate } from "./wallDecor.js";

export function createWallDecorTheme(template, input = {}) {
  if (!String(input.name || "").trim()) throw new Error("Motivnavn må fylles ut.");
  if (!input.previewUrl) throw new Error("Forhåndsvisningsbilde må lastes opp.");
  if (!input.productionAssetUrl) throw new Error("Produksjonsfil må lastes opp.");
  if (input.commercialRightsConfirmed !== true) throw new Error("Kommersielle rettigheter må bekreftes.");
  const field = (template.fields || []).find((item) => item.role === "wallDecorTheme");
  if (!field) throw new Error("Veggdekormalen mangler motivfelt.");
  const option = {
    value: uniqueValue(input.name, field.options || []),
    label: String(input.name).trim(),
    category: String(input.category || "Andre").trim() || "Andre",
    elementCount: Math.max(1, Math.round(Number(input.elementCount) || 1)),
    imageUrl: input.previewUrl,
    thumbnailUrl: input.previewUrl,
    productionAssetUrl: input.productionAssetUrl,
    productionWidth: Number(input.productionWidth) || 0,
    productionHeight: Number(input.productionHeight) || 0,
    productionHasTransparency: input.productionHasTransparency === true,
    roomImageUrl: input.roomImageUrl || "",
    ceilingSuitable: Boolean(input.ceilingSuitable),
    commercialRightsConfirmed: true,
    rightsNote: String(input.rightsNote || "Rettigheter bekreftet av administrator.").trim(),
    uploaded: true,
  };
  field.options ||= [];
  field.options.push(option);
  template.draftUpdatedAt = new Date().toISOString();
  return option;
}

export function validateWallDecorThemeInput(input = {}) {
  const errors = [];
  if (!String(input.name || "").trim()) errors.push("Motivnavn må fylles ut.");
  if (!input.previewUrl) errors.push("Forhåndsvisningsbilde må lastes opp.");
  if (!input.productionAssetUrl) errors.push("Produksjonsfil må lastes opp.");
  if (Number(input.productionWidth) < 1500 || Number(input.productionHeight) < 1000) errors.push("Produksjonsfilen må være minst 1500 × 1000 px.");
  if (input.productionHasTransparency !== true) errors.push("Produksjonsfilen må ha transparent bakgrunn slik at hvert element kan få egen skjærekontur.");
  if (input.commercialRightsConfirmed !== true) errors.push("Kommersielle rettigheter må bekreftes.");
  return errors;
}

export function validateWallDecorForPublication(template) {
  return validateWallDecorTemplate(template);
}

function uniqueValue(name, options) {
  const base = String(name).normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || "motiv";
  const existing = new Set(options.map((item) => item.value));
  if (!existing.has(base)) return base;
  let index = 2;
  while (existing.has(`${base}-${index}`)) index += 1;
  return `${base}-${index}`;
}
